module.exports = __webpack_public_path__ + "e59cc16dd973933b69c36dbeebbb7544.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/opensans-semibold/opensans-semibold.woff
// module id = ./src/styles/fonts/opensans-semibold/opensans-semibold.woff
// module chunks = index